"use client"
import React, { useEffect, useState, useRef } from 'react';
import { createRoot } from 'react-dom/client';
import DynamicPopup from '@/components/DynamicPopup/page';
import { TicketMap } from '@ticketevolution/seatmaps-client'
import { MdModeEdit } from "react-icons/md";
import moment from 'moment'
// import ticketGroups from '../../ticket-groups-1591449.json'
import { feathersClient } from '../../components/connection/page';
import { RxCross2 } from "react-icons/rx";
import { Button } from "@/components/ui/button"
import { GoArrowLeft } from "react-icons/go";
import { LuSofa } from "react-icons/lu";
import quad from "../../../public/4quad.svg"
import { Oswald, Roboto, Inter } from 'next/font/google';
import { CgSortAz } from "react-icons/cg";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { useDispatch } from 'react-redux';
import { AppDispatch, useAppSelector } from '@/redux/store';
import { updateCart } from '@/redux/features/cart-slice';
import { FaChevronDown } from "react-icons/fa";
import { UpdateBuyNow } from '@/redux/features/buynow-slice';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Link from 'next/link';
import { Loader2 } from 'lucide-react';
const oswalds = Oswald({ subsets: ['latin'] })
const roboto = Roboto({ weight: ['700',], subsets: ['latin'] })
const inter = Inter({ weight: ["300", "400", "500", "600", "700"], subsets: ["latin"] })
import ReactSlider from "react-slider";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
  SheetFooter,
  SheetClose,
} from "@/components/ui/sheet"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"


import Image from 'next/image';

let url: any;
if (typeof window !== "undefined") {
  url = localStorage.getItem("Frontend_API");
  // console.log(url);
}
let domain_url: any;

if (typeof window !== "undefined") {
  domain_url = localStorage.getItem("domain_url");
  // console.log(domain_url);
}
interface TicketGroup {

  format: string;
  retail_price: number;
  id: number;
  url: string;
  type: string;
  row: string; // Change the type of 'row' property to string
  section: string;
  quantity: number;
  available_quantity: number;
  wholesale_price: number;
  eticket: boolean;
  instant_delivery: boolean;
  intended_for_instant_delivery: boolean;
  tevo_section_name: string;
  splits: number[];
  wheelchair: boolean;
  public_notes: string;
}

interface Viewtickets {
  available_count: number;

  configuration: {
    id: string;
  };
  id: number;
  long_term_popularity_score: number;
  name: string;
  occurs_at: string;
  venue: {
    id: string;
    slug: string;
    url: string;
    slug_url: string;
    name: string;
    location: string;
    time_zone: string;
  };

}
interface ViewticketsProps {

  viewtickets: Viewtickets[];
  ticketGroup: TicketGroup[];

}
interface VenuePageProps {
  venueId: string;
  configurationId: string;
  ticketGroups: TicketGroup[];
  available_count: number;
  eventId: number;
  viewtickets: Viewtickets
}

interface PopupProps {
  quantity: number | 'All';
  setQuantity: (value: number | 'All') => void;
  onClose: () => void;
  eventId: number;
  setAvailableTicketGroups: (value: TicketGroup[]) => void;
  setAllTicketGroups: (value: TicketGroup[]) => void;
}
interface CartState {
  viewtickets: Viewtickets[];
  ticketGroup: TicketGroup[];
}
interface BuyNowState {
  viewtickets: Viewtickets[];
  ticketGroup: TicketGroup[];
}
function formatDate(inputDate: any) {
  const date = new Date(inputDate);

  const day = date.getUTCDate();
  const month = date.toLocaleDateString('en-US', { month: 'long', timeZone: 'UTC' });

  const formattedDate = `${month} ${day}`;
  return formattedDate;
}


function formatDay(inputDate: any): string {
  const date = new Date(inputDate);

  const dayName = date.toLocaleString('en-US', { weekday: 'long', timeZone: 'UTC' });

  return dayName;
}



function formatTime(inputDate: any): string {
  // Parse the input date using Moment.js
  const momentDate = moment.parseZone(inputDate);

  // Format the time in UTC using Moment.js in the desired format
  const formattedTime = momentDate.utc().format('hh:mm A');

  return formattedTime;
}
function formatYear(inputDate: any): string {
  const date = new Date(inputDate);
  const year = date.getFullYear();
  return String(year);
}
const Popup: React.FC<PopupProps> = ({ quantity, setQuantity, onClose, eventId, setAvailableTicketGroups, setAllTicketGroups }) => {
  // Add your popup content and select button logic here

  // const [quantity, setQuantity] = useState(2);
  // console.log(quantity);
  const [buttonLoading, setButtonLoading] = useState(false);

  const handleSelectClick = async () => {
    // Do something when the select button is clicke
    console.log("this is the quantity in pop up", quantity);
    if (quantity === 'All') {
      onClose();
      return
    }

    setButtonLoading(true);
    try {
      const response: any = await fetch(`${url}/api/sortfilters`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(
          {
            eventId: eventId,
            quantityFilter: quantity,
            ticketType: 'event'
          }
        ),
      })
      const data = await response.json();
      console.log('response from tickets groups', data.data);

      let filteredTicketData = [];
      if (quantity === 11) {
        filteredTicketData = data?.data
      } else {
        filteredTicketData = data?.data.filter((item: any) => {
          return item.splits && item.splits.includes(quantity);
        });
      }

      // const filteredTicketData = data?.data.filter((item: any) => {
      //   return item.splits && item.splits.includes(quantity);
      // });

      setAllTicketGroups(filteredTicketData);
      setAvailableTicketGroups(filteredTicketData);
      setButtonLoading(false);
      onClose();
    } catch (err) {
      setButtonLoading(false);
      console.log('Error in popup', err);
    }
  };

  return (
    <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 w-screen h-screen">

      <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>


      <div className="absolute w-[465px] max-[466px]:w-[200px] h-[523px] max-[466px]:h-[350px] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-md shadow-md z-50">
        <div className='flex justify-end p-1 cursor-pointer' onClick={onClose}><RxCross2 className='w-5 h-5 font-bold' /></div>
        <div className="px-6 rounded-lg flex-col justify-start items-center gap-4 inline-flex">
          {/* <div>cross</div> */}
          <div className="self-stretch h-20 flex-col justify-start items-center gap-2 sm:gap-3.5 flex">
            {/* <div>cross</div> */}
            <div className={`text-stone-900 max-[465px]:text-base text-3xl font-medium ${oswalds.className} leading-loose`}>How many tickets?</div>

            {/* <select value={quantity} aria-label='Quantity' name="quantity"
              onChange={(e) => {
                const value = e.target.value;
                if (value === "All") {
                  setQuantity("All");
                } else {
                  setQuantity(Number(value));
                }
              }}
              className='self-stretch min-[466px]:px-6 min-[466px]:py-2 bg-neutral-50 max-[466px]:text-xs rounded border border-neutral-400 justify-between items-center inline-flex '>
              <option value="" disabled >Quantity</option>
              <option value="All">All tickets</option>
              <option value="1">1 Ticket</option>
              <option value="2">2 Tickets</option>
              <option value="3">3 Tickets</option>
              <option value="4">4 Tickets</option>
              <option value="5">5 Tickets</option>
              <option value="6">6 Tickets</option>
              <option value="7">7 Tickets</option>
              <option value="8">8 Tickets</option>
              <option value="9">9 Tickets</option>
              <option value="10">10 Tickets</option>
            </select> */}
            <Select value={quantity.toString()} onValueChange={(e) => {
              if (e === "All") {
                setQuantity("All");
              } else {
                setQuantity(Number(e));
              }
            }}
            >

              <SelectTrigger className="w-full border border-neutral-400">
                <SelectValue placeholder="Quantity" />
              </SelectTrigger>
              <SelectContent className="!max-h-[400px]  overflow-y-auto">
                <SelectGroup>
                  <SelectLabel>Quantity</SelectLabel>
                  <SelectItem value="All">All Tickets</SelectItem>
                  {Array.from({ length: 10 }, (_, i) => (
                    <SelectItem key={i + 1} value={(i + 1).toString()}>{`${i + 1} Ticket${i + 1 > 1 ? 's' : ''}`}</SelectItem>
                  ))}
                  <SelectItem value="11">10+ Tickets</SelectItem>
                </SelectGroup>
              </SelectContent>
            </Select>
            <div className='flex items-center gap-2'>
              <h5 className={`text-sm font-medium text-[#4F89FA] text-center leading-tight sm:leading-normal ${roboto.className}`}>
                ALL SEATS ARE TOGETHER UNLESS OTHERWISE NOTED
              </h5>
              <LuSofa className='text-[#4F89FA] hidden sm:block' />
            </div>

            <div className='flex items-center gap-2'>
              <h5 className={`text-[#FF6F00] font-medium leading-tight sm:leading-none text-center ${roboto.className} text-sm md:text-x uppercase xl:normal-case`}>
                {/* SEAT NUMBERS ARE NOT DISPLAYED ON THIS SITE */}
                Seats numbers are <span className="text-[#4f89fa] uppercase">not</span> displayed on this site
                <br />
                <br className="block md:hidden" />
                <br className="hidden md:block" />
                <br className="hidden md:block" />
                {/* AISLE SEATS ARE NOT DISPLAYED ON THIS SITE */}
                Aisle seats are <span className="text-[#4f89fa] uppercase">not</span> displayed on this site
              </h5>
            </div>








            <div className={`container max-[466px]:hidden w-50 h-40 px-2 py-2 items-start gap-4 inline-flex flex-col ${roboto.className}`}>

              <div className="flex gap-4 items-center">
                <div className="w-48 h-[84px] px-2 py-1  bg-[#011B70] rounded-lg flex-col justify-center items-center gap-2 inline-flex">
                  <div className="justify-start items-end gap-1 inline-flex">
                    {/* <Image src="/tick.svg" alt="tick" height={5} width={5} className='w-5 h-5' /> */}
                    <div className="text-white text-base font-bold  leading-tight">Have a Question ?</div>
                  </div>
                  {/* <div className="self-stretch text-center text-white text-xs font-normal">Please Read our FAQ's Page to assist you especially after placing an order</div> */}
                  <div className="self-stretch text-center text-white text-xs font-normal">Please Read our <Link href="/faq"><span className="underline italic">FAQ's</span></Link> page</div>
                </div>
                <div className="w-48 px-2 py-1 bg-[#011B70] rounded-lg flex-col justify-center items-center gap-2 inline-flex">
                  <div className="justify-center items-center gap-1 inline-flex">
                    {/* <Image src="/tick.svg" alt="tick" height={5} width={5} className='w-5 h-5' /> */}
                    <div className="text-white text-base font-bold leading-tight">Customer Care</div>
                  </div>
                  <div className="self-stretch text-center text-white text-xs font-normal">7 days a week 9:30 am to 10 pm EST visit our <Link href="/contactus"><span className="underline italic">Contact Us</span></Link> page to connect</div>
                </div>

              </div>
              <div className="flex gap-4 items-center">
                <div className="w-48  px-2 py-1 bg-[#011B70] rounded-lg flex-col justify-center items-center gap-2 inline-flex">
                  <div className="justify-start items-start gap-1 inline-flex">
                    {/* <div className="w-6 h-6 flex" /> */}
                    {/* <img className="w-6 h-6" alt="" src="/tick.svg" /> */}
                    {/* <Image src="/tick.svg" alt="tick" height={5} width={5} className='w-5 h-5' /> */}
                    <div className="text-white text-base font-bold  leading-tight">Valid Seats</div>
                  </div>
                  <div className="self-stretch text-center text-white text-xs font-normal">All listed tickets are valid and ready to be shipped on the assigned delivery date</div>
                </div>

                <div className="w-48 px-2 py-1 bg-[#011B70] rounded-lg flex-col justify-center items-center gap-2 inline-flex">
                  <div className="justify-start items-end gap-1 inline-flex">
                    {/* <Image src="/tick.svg" alt="tick" height={5} width={5} className='w-5 h-5' /> */}
                    <div className="text-white text-base font-bold leading-tight">Full Refund</div>
                  </div>
                  <div className="self-stretch text-center text-white text-xs font-normal">On all cancelled events, please read our <Link href="/faq"><span className="underline italic">FAQ's page</span></Link> for more details.</div>
                </div>

              </div>
              {/* Bottom section */}
            </div>


            <div className='w-full md:mt-10 flex justify-center '>
              <button className={`max-[466px]:text-xs text-white w-3/5 py-2 px-4 rounded-full ${roboto.className} ${buttonLoading ? 'bg-gradient-to-r from-[#FF6F00] to-[#FF8F33] bg-[length:200%_100%] animate-skeleton' : 'bg-[#FF6F00]'}`} disabled={buttonLoading} onClick={handleSelectClick}>
                Select
              </button>
            </div>
          </div>
        </div >

      </div>
      {/* <Map/> */}
    </div>
  );
};




const App: React.FC<VenuePageProps> = ({ venueId, configurationId, ticketGroups, available_count, eventId, viewtickets }) => {
  console.log('ticketGroups.length', ticketGroups.length);
  // console.log(viewtickets)
  // console.log()
  const dispatch = useDispatch<AppDispatch>();
  const cartArray = useAppSelector((state) => state.cartReducer);
  const buyNow = useAppSelector((state) => state.buyNowReducer);
  const rootRef = useRef(null);
  const [showPopup, setShowPopup] = useState(true);
  const [allTicketGroups, setAllTicketGroups] = useState<TicketGroup[]>(ticketGroups);
  const [quantityFilter, setQuantityFilter] = useState<number | 'All'>('All');
  const [minPriceFilter, setMinPriceFilter] = useState(0);
  const [maxPriceFilter, setMaxPriceFilter] = useState(1000);
  const [changePrice, setChangePrice] = useState(1000);
  const [typeFilter, setTypeFilter] = useState<Set<string>>(new Set());
  const [selectedTicketGroup, setSelectedTicketGroup] = useState<TicketGroup | null>(null); // Track the hovered ticket
  const [availableTicketGroups, setAvailableTicketGroups] = useState<TicketGroup[]>(ticketGroups);
  const [isOpen, setIsOpen] = useState(false);
  const [sortbystate, setSortbystate] = useState("SORT BY");
  const [isEditing, setIsEditing] = useState(false);
  const [cad_rate, setCadRate] = useState(0);
  const toggleDropdown = () => setIsOpen(!isOpen);
  const [loading, setLoading] = useState(false);
  const [selectedSections, setSelectedSections] = useState<string[]>([]);
  const [type, setType] = useState('retail_price');
  const [order, setOrder] = useState('ASC');
  const [ticketType, setTicketType] = useState('event');
  const isInitialMount = useRef(true);
  const typeRef = useRef(type);
  const orderRef = useRef(order);
  const quantityRef = useRef(quantityFilter);
  const minPriceRef = useRef(minPriceFilter);
  const maxPriceRef = useRef(maxPriceFilter);
  const cadRateRef = useRef(cad_rate);
  const [parkingTickets, setParkingTickets] = useState<TicketGroup[]>([]);
  const [showPopup1, setShowPopup1] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [buttonText, setButtonText] = useState("");

  useEffect(() => {
    const parking: TicketGroup[] = [];
    const nonParking: TicketGroup[] = [];

    ticketGroups.forEach((tg) => {
      if (tg.type === "parking") {
        parking.push(tg);
      } else {
        nonParking.push(tg);
      }
    });

    setParkingTickets(parking);
    setAllTicketGroups(nonParking);
    setAvailableTicketGroups(nonParking);
  }, []);


  useEffect(() => {
    typeRef.current = type;
    orderRef.current = order;
    quantityRef.current = quantityFilter;
    minPriceRef.current = minPriceFilter;
    maxPriceRef.current = maxPriceFilter;
    cadRateRef.current = cad_rate;
  }, [type, order, quantityFilter, minPriceFilter, maxPriceFilter, cad_rate]);

  const dropdownRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsEditing(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  useEffect(() => {
    const exhangeRate = async () => {
      const response = await feathersClient.service('api/v1/exchangerates').find({
        query: {
          $sort: {
            date: -1
          },
          $limit: 1
        }
      });
      console.log("response", response)
      setCadRate(response.data[0]?.cad_rate);
      localStorage.setItem('cad_rate', response.data[0]?.cad_rate);
    }
    exhangeRate();
  }, [])

  useEffect(() => {
    if (showPopup) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [showPopup]);

  const createHeading = (section: string, row: string): JSX.Element => {
    return <div>
      <h1 className={`${roboto.className} text-sm md:text-base font-bold`}>{`Section ${section}`}</h1>
      <h1 className={`${roboto.className} text-sm md:text-base font-semibold`}>{`Row ${row}`}</h1>
    </div>
  };

  const createType = (format: string): JSX.Element => {
    return <h2 className='text-[13px]'>{format}</h2>;
  };

  const createQuantity = (splits: number[]): JSX.Element => {
    let splitStart = splits[0];
    if (quantityFilter === 11) {
      splitStart = splits.find((split) => split === 11) || splits.find((split) => split > 11) || splits[0];
    }
    let splitEnd = splits[splits.length - 1];
    return (
      <h3 className='text-xs text-[#397BEA] flex flex-row items-center'>
        {quantityFilter === 'All' || quantityFilter === 11 ? `${splitStart !== splitEnd ? `${splitStart} - ${splitEnd} tickets` : `${splitStart} tickets`}, seated together` : quantityFilter > 1 ? `${quantityFilter} tickets, seated together` : `${quantityFilter} ticket`}
        {/* {quantityFilter >= 11 ? '10+' : quantityFilter} ticket */}
        {/* {quantityFilter > 1 && 's, seated together'} */}
        &nbsp;
        {(quantityFilter !== 'All' && quantityFilter > 1) && <LuSofa className='text-[#141d2d]' />}
      </h3>
    );
  };

  // const createQuantityy = (quantity: number): JSX.Element => {
  //   return (
  //     <h3 className='text-xs text-[#397BEA] flex flex-row items-center'>
  //       {quantityFilter} ticket
  //       {quantityFilter > 1 && 's, seated together'}
  //       &nbsp;
  //       {quantityFilter > 1 && <LuSofa className='text-[#141d2d]' />}
  //     </h3>
  //   );
  // };

  const handleTicketGroupClick = (ticketGroup: TicketGroup) => {
    setSelectedTicketGroup(ticketGroup);
    // setInitialQuantity(selectedTicketGroup?.quantity || 0);
    console.log("splits array of the selected ticket group : ", ticketGroup.splits)
  };

  // const handleTicketHover = (sectionName: string) => {
  //   // Call the method to highlight the region in the map
  //   // This depends on the implementation of your TicketMap component
  //   rootRef.highlightSection(sectionName);
  // };

  // const handleTicketUnhover = (sectionName: string) => {
  //   // Call the method to remove the highlight from the map
  //   // This depends on the implementation of your TicketMap component
  //   map.unhighlightSection(sectionName);
  // };
  const createTicketGroupListItem = (ticketGroup: TicketGroup, index: number): JSX.Element => {
    // const isHovered = ticketGroup === hoveredTicket; // Check if the ticket is currently hovered
    // const seatClassName = isHovered ? 'highlighted-seat' : ''; // Apply the CSS class if hovered
    return (
      <div key={index}
        className={` bg-white rounded-xl lg:py-4 lg:px-8  p-2 w-full flex flex-row items-center justify-between cursor-pointer transition duration-300 hover:shadow-sm hover:scale-[1.02] gap-2`}
        data-section={ticketGroup.tevo_section_name}
        onClick={() => { handleTicketGroupClick(ticketGroup) }}
      //       onMouseEnter={() => handleTicketHover(ticketGroup.section)}
      // onMouseLeave={() => handleTicketUnhover(ticketGroup.section)}
      >

        <div className='w-full flex justify-between'>

          <div className='w-[60%] lg:w-auto'>
            {createHeading(ticketGroup.section, ticketGroup.row)}
            {ticketType !== 'parking' && createQuantity(ticketGroup.splits)}
            {createType(ticketGroup.format)}
            {/* <div className='flex flex-row items-center gap-1'>
            <h1 className='text-gray-400 text-xs'>Clear view </h1>
            <IoIosInformationCircleOutline className='font-bold text-gray-400' />
          </div> */}
          </div>

          {/* {createQuantity(ticketGroup.retail_price)} */}
          <div className='flex flex-col items-end gap-1'>
            <div className='flex flex-col items-end'>
              <div className='font-bold text-[#40B41C] text-right'>CA$ {(cad_rate * ticketGroup.retail_price).toFixed(2)}</div>
              <h2 className='text-sm text-gray-400'>each</h2>
            </div>

            {ticketGroup?.wheelchair && (
              <div className='w-[24px] sm:w-[52px] h-[24px] sm:h-[48px] p-1 rounded-sm flex flex-col items-start sm:items-center justify-center gap-1'>
                <div><Image src={'/wheelchair.svg'} alt='wheelchair' width={16} height={16} /></div>
                <div className='hidden sm:block'>
                  <p className={`text-[8px] font-base text-[#4169E1] text-center leading-none ${roboto.className}`}>Wheelchair accessible</p>
                </div>
              </div>
            )}
            {ticketGroup?.tevo_section_name &&
              (ticketGroup.tevo_section_name.toLowerCase().includes("standing") ||
                ticketGroup.tevo_section_name.toLowerCase().includes("sro")) && (
                <div className='w-[24px] sm:w-[52px] h-[24px] sm:h-[48px] p-1 rounded-sm flex flex-col items-start sm:items-center justify-center gap-1'>
                  <div>
                    <Image src={'/standing.svg'} alt='standing' width={16} height={16} />
                  </div>
                  <div className='hidden sm:block'>
                    <p className={`text-[8px] font-base text-[#4169E1] text-center leading-none ${roboto.className}`}>
                      Standing Ticket
                    </p>
                  </div>
                </div>
              )
            }



          </div>


        </div>
      </div>
    );
  };
  const containerRef = React.useRef<HTMLDivElement | null>(null);


  let filterTicketGroups = (allTickets: TicketGroup[], quantity: any, maxFilter: any, minFilter: any, cadRate: any) => {
    console.log('filtergroups is called');
    // console.log('maxPriceFilter : ', maxFilter);
    // console.log('minPriceFilter : ', minFilter);
    // console.log('quantity : ', quantity);
    // console.log('allTickets : ', allTickets.length);
    // console.log('cad_rate : ', cad_rate);
    let filteredTicketGroups = allTickets;

    if (quantity === 'All' || quantity === 11) {
      console.log('Inside quantity filter All');
      filteredTicketGroups = allTickets.filter(ticketGroup => {
        //console.log('Ticket Group:', ticketGroup);
        return (ticketGroup?.retail_price * cadRate) >= minFilter &&
          (ticketGroup?.retail_price * cadRate) <= maxFilter
      });

    } else {
      console.log('Inside quantity filter based on quantity');
      filteredTicketGroups = allTickets.filter(ticketGroup => {
        let isSplitMatch = ticketGroup.splits && ticketGroup.splits.includes(quantity);

        return (isSplitMatch) &&
          (ticketGroup?.retail_price * cadRate) >= minFilter &&
          (ticketGroup?.retail_price * cadRate) <= maxFilter &&
          (typeFilter.size === 0 || typeFilter.has(ticketGroup.format));

      });

    }
    console.log('filteredTicketGroups : ', filteredTicketGroups.length);
    setAvailableTicketGroups(filteredTicketGroups);
  };


  useEffect(() => {
    if (cad_rate > 0) {
      setPriceRange();
    }
  }, [cad_rate]);

  useEffect(() => {

    if (quantityFilter !== null && cad_rate > 0) {
      let filteredTicketGroupsBasedOnSection = allTicketGroups;
      if (selectedSections.length > 0) {
        filteredTicketGroupsBasedOnSection = allTicketGroups.filter(
          (ticketGroup) =>
            selectedSections.includes(ticketGroup.tevo_section_name)
        );
      }
      filterTicketGroups(filteredTicketGroupsBasedOnSection, quantityFilter, maxPriceFilter, minPriceFilter, cad_rate);
    }

  }, [quantityFilter, maxPriceFilter, cad_rate]);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      handleClick();
    }
  }, [type, order, quantityFilter, ticketType]);


  useEffect(() => {
    const storedRedirectUrl = localStorage.getItem("redirectUrl");
    if (storedRedirectUrl) {
      // setRedirectUrl(storedRedirectUrl); // Save it in state
      localStorage.removeItem("redirectUrl"); // Remove from localStorage
    }
  }, []);

  const updateFilters = (name: string, value: string | number) => {
    if (name === 'quantity' && value === 'All') {
      setQuantityFilter(value);
      return;
    }

    const numericValue = typeof value === 'string' ? parseFloat(value) : value;

    switch (name) {
      case "quantity":
        setQuantityFilter(numericValue as number);
        break;
      case "min-price":
        setMinPriceFilter(numericValue as number);
        break;
      case "max-price":
        setMaxPriceFilter(numericValue as number);
        break;
      case "type":
        if (typeFilter.has(value as string)) {
          typeFilter.delete(value as string);
        } else {
          typeFilter.add(value as string);
        }
        setTypeFilter(new Set(typeFilter));
        break;
      default:
    }
  };


  const setPriceRange = () => {
    const minPrice = allTicketGroups[0]?.retail_price;
    console.log(minPrice)
    const maxPrice = allTicketGroups[allTicketGroups.length - 1]?.retail_price;
    console.log(maxPrice)
    setMinPriceFilter(Math.floor(minPrice * cad_rate));
    setChangePrice(Math.ceil(maxPrice * cad_rate));
    setMaxPriceFilter(Math.ceil(maxPrice * cad_rate));
  };

  const renderTicketGroupList = (ticketGroups: TicketGroup[]): JSX.Element => {
    return (
      <div>
        <div
          className='flex flex-col gap-2 overflow-y-auto scroll-m-1 p-2'
          style={{ height: 'calc(100vh - 200px)', scrollbarWidth: 'thin', msOverflowStyle: 'none' }}
          ref={containerRef}
        >
          {ticketGroups && ticketGroups.map((ticketGroup: TicketGroup, index: number) =>
            createTicketGroupListItem(ticketGroup, index)
          )}

        </div>
        {ticketGroups.length > 7 && (<button className="w-full rounded-xl py-4 bg-gray-300 font-bold text-xl" onClick={() => containerRef.current?.scrollTo({ top: 0, behavior: 'smooth' })}>
          Back to Top
        </button>)}
        {isPWA && <>
          <br />
          <br />
          <br />
          <br />
        </>}
      </div>
    );
  };


  // console.log(ticketGroups)
  let isValid = true;
  let validationMessage = "";
  let validationButtonText = "";

  const addToCart = async (ticket: TicketGroup, viewticket: Viewtickets) => {
    console.log('add to cart', ticket);

    const itemIndex = cartArray.ticketGroup.findIndex((item) => item.id === ticket.id);

    if (itemIndex !== -1) {
      // item is in cart
      // update the quantity
      // const updatedCart = cartArray.map((cartState, index) =>
      //   index === itemIndex
      //     ? {
      //         ...cartState,
      //         viewtickets: viewticket,
      //         ticketGroup: cartState.ticketGroup.map((item) =>
      //           item.id === ticket.id ? { ...item, quantity: item.quantity + 1 } : item
      //         ),
      //       }
      //     : cartState
      // );

      // dispatch(updateCart(updatedCart));
      console.log("Already added to cart")
      // toast.error('Already added to cart', { autoClose: 2000 });
      isValid = false;
      validationMessage = "This ticket is already in your cart.";
      validationButtonText = "Try Other";
      if (!isValid) {
        setPopupMessage(validationMessage);
        setButtonText(validationButtonText);
        setShowPopup1(true);
        return;
      }
    } else {
      // item is not in cart
      const newCartItem: ViewticketsProps = {
        viewtickets: [{
          available_count: viewticket.available_count,

          configuration: {
            id: viewticket.configuration.id,
          },
          id: viewticket.id,
          long_term_popularity_score: viewticket.long_term_popularity_score,
          name: viewticket.name,
          occurs_at: viewticket.occurs_at,
          venue: {
            id: viewticket.venue.id,
            slug: viewticket.venue.slug,
            url: viewticket.venue.url,
            slug_url: viewticket.venue.slug_url,
            name: viewticket.venue.name,
            location: viewticket.venue.location,
            time_zone: viewticket.venue.time_zone,
          },
        }],
        ticketGroup: [
          {
            format: ticket.format,
            retail_price: ticket?.retail_price,
            id: ticket.id,
            type: ticket.type,
            row: ticket.row, // Change the type of 'row' property to string
            section: ticket.section,
            quantity: quantityFilter !== 'All' ? quantityFilter : ticket.splits[0],
            splits: ticket.splits,
            available_quantity: ticket.available_quantity,
            wholesale_price: ticket.wholesale_price,
            eticket: ticket.eticket,
            instant_delivery: ticket.instant_delivery,
            tevo_section_name: ticket.tevo_section_name,
            url: "", // Add the missing 'url' property
            intended_for_instant_delivery: false, // Add the missing 'intended_for_instant_delivery' property
            wheelchair: ticket.wheelchair,
            public_notes: ticket.public_notes
          },
        ],
      };
      const updatedCart: CartState = {
        viewtickets: [...cartArray.viewtickets, ...newCartItem.viewtickets],
        ticketGroup: [...(cartArray.ticketGroup as TicketGroup[]), ...(newCartItem.ticketGroup as TicketGroup[])],
      };


      localStorage.setItem('cart', JSON.stringify(updatedCart));

      const user = localStorage.getItem('users')
      console.log("user details ", user);
      if (user) {

        const parsedUser = JSON.parse(user);

        const userId = parsedUser._id;
        const newUpdatedCart = {
          userId: userId,
          cartItems: [
            {
              viewtickets: updatedCart.viewtickets.map(item => ({
                ...item,
                configuration: item.configuration && item.configuration.id ? {
                  ...item.configuration,
                  id: String(item.configuration.id),
                } : item.configuration,
                venue: item.venue ? {
                  ...item.venue,
                  id: item.venue.id ? String(item.venue.id) : item.venue.id,
                  time_zone: item.venue.time_zone !== null ? String(item.venue.time_zone) : "null",
                } : item.venue,
              })),
              ticketGroup: updatedCart.ticketGroup,
            },
          ],
        };
        console.log(newUpdatedCart);
        const existingCart = await feathersClient.service('api/v1/cart').find({ query: { userId: userId } });
        console.log("alr exisitng", existingCart);
        if (existingCart.data && existingCart.data.length > 0) {
          // A cart with the user's ID exists, update the cart
          console.log("shhsc nas ", existingCart.data[0].userId);
          const response = await feathersClient.service('api/v1/cart').patch(null, newUpdatedCart, {
            query: { userId: existingCart.data[0].userId }
          });
          // let isValid = true;
          // let validationMessage = "";
          // let validationButtonText = "";
          console.log('Cart updated:', response);
          dispatch(updateCart(updatedCart));
          //toast.success('Added to cart!', { autoClose: 2000 });
          isValid = false;
          validationMessage = " Ticket successfully added to your cart!";
          validationButtonText = "Add More";
        } else {
          // No cart with the user's ID exists, create a new cart
          const response = await feathersClient.service('api/v1/cart').create(newUpdatedCart);
          console.log('Cart created:', response);
          dispatch(updateCart(updatedCart));
          //toast.success('Added to cart!', { autoClose: 2000 });
          isValid = false;
          validationMessage = " Ticket successfully added to your cart!";
          validationButtonText = "Add More";
        }
        console.log('Form data successfully saved to the user table via Feathers service:', existingCart.data);

        console.log('Data saved');
      }

      if (!user) {
        dispatch(updateCart(updatedCart));
        //toast.success('Added to cart!', { autoClose: 2000 });
        isValid = false;
        validationMessage = "Added to cart!";
        validationButtonText = "Add More";
      }
      if (!isValid) {
        setPopupMessage(validationMessage);
        setButtonText(validationButtonText);
        setShowPopup1(true);
        return;
      }
    }

  };

  const addtobuyNow = async (ticket: TicketGroup, viewticket: Viewtickets) => {
    setLoading(true);
    const newBuyNowItem: ViewticketsProps = {
      viewtickets: [{
        available_count: viewticket.available_count,

        configuration: {
          id: viewticket.configuration.id,
        },
        id: viewticket.id,
        long_term_popularity_score: viewticket.long_term_popularity_score,
        name: viewticket.name,
        occurs_at: viewticket.occurs_at,
        venue: {
          id: viewticket.venue.id,
          slug: viewticket.venue.slug,
          url: viewticket.venue.url,
          slug_url: viewticket.venue.slug_url,
          name: viewticket.venue.name,
          location: viewticket.venue.location,
          time_zone: viewticket.venue.time_zone,
        },
      }],
      ticketGroup: [
        {
          format: ticket.format,
          retail_price: ticket?.retail_price,
          id: ticket.id,
          type: ticket.type,
          row: ticket.row, // Change the type of 'row' property to string
          section: ticket.section,
          quantity: quantityFilter !== 'All' ? quantityFilter : ticket.splits[0],
          splits: ticket.splits,
          available_quantity: ticket.available_quantity,
          wholesale_price: ticket.wholesale_price,
          eticket: ticket.eticket,
          instant_delivery: ticket.instant_delivery,
          tevo_section_name: ticket.tevo_section_name,
          url: "", // Add the missing 'url' property
          intended_for_instant_delivery: false, // Add the missing 'intended_for_instant_delivery' property
          wheelchair: ticket.wheelchair,
          public_notes: ticket.public_notes
        },
      ],
    };
    const UpdatedBuyNow: BuyNowState = {
      viewtickets: [...newBuyNowItem.viewtickets],
      ticketGroup: [...newBuyNowItem.ticketGroup]
    }
    dispatch(UpdateBuyNow(UpdatedBuyNow));

    const redirectUrl = localStorage.setItem('redirectUrl', window.location.pathname);
    console.log("redirectUrl", redirectUrl)

    const buynowItemsFromLocalStorage = localStorage.getItem('buyNow');

    if (buynowItemsFromLocalStorage) {  // Check if buynowItemsFromLocalStorage is not null
      const parsedBuynowItems = JSON.parse(buynowItemsFromLocalStorage);


      if (parsedBuynowItems.client) {
        const newBuyNow = {
          client: parsedBuynowItems.client,
          viewtickets: [...newBuyNowItem.viewtickets],
          ticketGroup: [...newBuyNowItem.ticketGroup]
        }
        // parsedBuynowItems.ticketGroup =  UpdatedBuyNow.ticketGroup;
        // parsedBuynowItems.viewtickets = UpdatedBuyNow.viewtickets;
        localStorage.setItem('buyNow', JSON.stringify(newBuyNow));
      } else {
        localStorage.setItem('buyNow', JSON.stringify(UpdatedBuyNow));
      }
    } else {
      localStorage.setItem('buyNow', JSON.stringify(UpdatedBuyNow));
    }


    //localStorage.setItem('buyNow', JSON.stringify(UpdatedBuyNow));

    setTimeout(() => {
      setLoading(false);
    }, 2000);
    // Fix: Pass the action creator function instead of the state object directly
    //  console.log(buyNow)
  }

  const filterTicketGroupsBasedOnOrderandType = (ticketGroups: TicketGroup[]) => {
    return ticketGroups.sort((a: any, b: any) => {
      if (orderRef.current === 'ASC') {
        if (typeRef.current === 'retail_price') {
          return a.retail_price - b.retail_price;
        } else if (typeRef.current === 'section') {
          return a.section.localeCompare(b.section);
        } else if (typeRef.current === 'row') {
          return a.row.localeCompare(b.row);
        }
      } else if (orderRef.current === 'DESC') {
        if (typeRef.current === 'retail_price') {
          return b.retail_price - a.retail_price;
        } else if (typeRef.current === 'section') {
          return b.section.localeCompare(a.section);
        } else if (typeRef.current === 'row') {
          return b.row.localeCompare(a.row);
        }
      }
    });
  }

  // let handleSelection = (selectedSections: any) => {
  //   setSelectedSections(selectedSections);
  //   // console.log(retail_price)
  //   // console.log(price)
  //   console.log("selectedSections on map", selectedSections);
  //   if (selectedSections.length > 0) {
  //     let filteredTicketGroupsBasedOnSection = availableTicketGroups.filter(
  //       (ticketGroup) =>
  //         quantityRef.current === 'All' ? selectedSections.includes(ticketGroup.tevo_section_name) && (ticketGroup.retail_price <= maxPriceRef.current && ticketGroup.retail_price >= minPriceRef.current) :
  //           selectedSections.includes(ticketGroup.tevo_section_name) && (ticketGroup.retail_price <= maxPriceRef.current && ticketGroup.retail_price >= minPriceRef.current) && (ticketGroup.splits.includes(quantityRef.current))
  //     );

  //     let sortedTicketGroups = filterTicketGroupsBasedOnOrderandType(filteredTicketGroupsBasedOnSection);

  //     setAvailableTicketGroups(sortedTicketGroups);

  //   } else {
  //     let sortedTicketGroups = filterTicketGroupsBasedOnOrderandType(availableTicketGroups);
  //     //console.log("sortedTicketGroups", sortedTicketGroups);
  //     filterTicketGroups(sortedTicketGroups, quantityRef.current, maxPriceRef.current, minPriceRef.current, cadRateRef.current);
  //   }
  // };


  let handleSelection = (selectedSections: any) => {
    setSelectedSections(selectedSections);
    console.log("selectedSections on map", selectedSections);

    // Normalize selected section names
    const normalizedSelectedSections = selectedSections.map((s: string) =>
      s?.trim().toLowerCase()
    );

    if (selectedSections.length > 0) {
      let filteredTicketGroupsBasedOnSection = availableTicketGroups.filter((ticketGroup) => {
        const sectionName = ticketGroup.tevo_section_name?.trim().toLowerCase();
        console.log("sectionName", sectionName);
        console.log("normalizedSelectedSections", normalizedSelectedSections);
        const isInSection = normalizedSelectedSections.includes(sectionName);
        console.log("isInSection", isInSection);
       

        const price = Number(ticketGroup.retail_price * cadRateRef.current); // Assuming 1.370562 is the CAD rate
        const isInPriceRange =
          price <= Number(maxPriceRef.current) &&
          price >= Number(minPriceRef.current);

        if (!isInSection || !isInPriceRange) return false;
        console.log("quantityRef.current", quantityRef.current);

        // Only apply quantity filtering when quantityRef is NOT 'All'
        if (quantityRef.current !== 'All') {
          const splits = ticketGroup.splits || [];
          
          // Force both to be numbers for accurate comparison
          return splits.includes(Number(quantityRef.current));
        }

        return true;
      });

      let sortedTicketGroups = filterTicketGroupsBasedOnOrderandType(filteredTicketGroupsBasedOnSection);
      console.log("sortedTicketGroups", sortedTicketGroups);
      setAvailableTicketGroups(sortedTicketGroups);
    } else {
      // No section selected – fallback behavior
      let sortedTicketGroups = filterTicketGroupsBasedOnOrderandType(availableTicketGroups);
      filterTicketGroups(
        sortedTicketGroups,
        quantityRef.current,
        Number(maxPriceRef.current),
        Number(minPriceRef.current),
        cadRateRef.current
      );
    }
  };

  // const handleHover = (sectionId:any, event:any,retail_price:any) => {
  //   console.log("Hovered section ID:", sectionId);
  //   console.log("Event data:", event);
  //   // Add any additional logic you want to perform on hover
  // };



  useEffect(() => {
    // Retrieve cart from local storage
    const storedUser = localStorage.getItem('users');

    if (storedUser) {
      // Parse storedUser from JSON string to object
      const parsedUser = JSON.parse(storedUser);

      // Fetch cart from the database using the userId
      feathersClient.service('api/v1/cart').find({ query: { userId: parsedUser._id } })
        .then((existingCart: any) => {
          if (existingCart.data && existingCart.data.length > 0) {
            // Check if ticketGroup is an array
            // console.log(existingCart.data[0].cartItems[0].ticketGroup)
            if (Array.isArray(existingCart.data[0].cartItems[0].ticketGroup)) {
              // Update cartArray with existingCart
              dispatch(updateCart(existingCart.data[0].cartItems[0]));
            } else {
              console.error('ticketGroup is not an array:', existingCart.data[0].cartItems.ticketGroup);
            }
          }
        })
        .catch((error: any) => {
          console.error('Error fetching cart:', error);
        });
    } else {
      // Retrieve cart from local storage
      const storedCart = localStorage.getItem('cart');

      if (storedCart) {
        // Parse storedCart from JSON string to object
        const parsedCart: CartState = JSON.parse(storedCart);

        // Update cartArray with parsedCart
        dispatch(updateCart(parsedCart));
      }
    }
  }, []);

  useEffect(() => {
    if (!rootRef.current) {
      throw new Error("Root element not found");
    }
    const sectionPercentiles = {
      '0.2': '#2563EB',
      '0.4': '#2563EB',
      '0.6': '#2563EB',
      '0.8': '#2563EB',
      '1': '#2563EB'
    };


    const rootEl = rootRef.current;
    const root = createRoot(rootEl);

    root.render((
      <TicketMap
        venueId={venueId}
        configurationId={configurationId}
        ticketGroups={availableTicketGroups}
        onSelection={handleSelection}
        mouseControlEnabled={true}
        sectionPercentiles={sectionPercentiles}
      //onHover={handleHover} 
      />

    ));

  }, []);

  const handlePopupClose = () => {
    setShowPopup(false);
    // You can perform additional actions when the popup is closed
  };
  // console.log(quantity);

  const handleTicketTypeChange = (selectedTicketType: string) => {
    setTicketType(selectedTicketType);
  }

  const handleDropdownChange = (selectedType: string, selectedOrder: string) => {
    setType(selectedType);
    setOrder(selectedOrder);
    toggleDropdown();
  };

  const handleClick = async () => {

    const requestBody = {
      eventId: eventId,
      type: type,
      order: order,
      quantityFilter: ticketType === 'parking' ? 'All' : quantityFilter,
      ticketType: ticketType
    }
    const response = await fetch(`${url}/api/sortfilters`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(
        requestBody,
      ),
    });
    const data = await response.json();

    console.log('Data from sort by API', data?.data);
    if (ticketType === 'parking') {
      setParkingTickets(data?.data);
    } else {

      setAllTicketGroups(data?.data);

      let filteredTicketGroupsOnSection = data?.data.filter(
        (ticketGroup: any) =>
          selectedSections.length === 0 ||
          selectedSections.includes(ticketGroup.tevo_section_name),
      );

      console.log('filteredTicketGroupsOnSection:', filteredTicketGroupsOnSection);
      filterTicketGroups(filteredTicketGroupsOnSection, quantityFilter, maxPriceFilter, minPriceFilter, cad_rate);

    }

    if (type === "retail_price") {
      if (order === "ASC") {
        const text = "Price - Ascending";
        setSortbystate(text);
      }
      else if (order === "DESC") {
        const text = "Price - Descending";
        setSortbystate(text);
      }
    }
    else if (type === "section") {
      if (order === "ASC") {
        const text = "Section - Ascending";
        setSortbystate(text);
      }
      else if (order === "DESC") {
        const text = "Section - Descending";
        setSortbystate(text);
      }
    }
    else if (type === "row") {
      if (order === "ASC") {
        const text = "Row - Ascending";
        setSortbystate(text);
      }
      else if (order === "DESC") {
        const text = "Row - Descending";
        setSortbystate(text);
      }
    }

  };


  console.log('all ticket groups', allTicketGroups.length);
  console.log('available ticket groups', availableTicketGroups.length);

  const isPWA = useAppSelector((state: any) => state.pwacheckReducer.isPWA);


  return (
    <div>
      {showPopup && <Popup quantity={quantityFilter} setQuantity={setQuantityFilter} onClose={handlePopupClose} eventId={eventId} setAvailableTicketGroups={setAvailableTicketGroups} setAllTicketGroups={setAllTicketGroups} />}
      {/* {showPopup1 && (
        <DynamicPopup message={popupMessage} buttonText={buttonText} onClose={() => setShowPopup1(false)} />
      )} */}
      <div className={`fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm ${showPopup ? 'block' : 'hidden'}`}></div>
      {/* <ToastContainer /> */}
      {showPopup1 && (
        <DynamicPopup message={popupMessage} buttonText={buttonText} onClose={() => setShowPopup1(false)} />
      )}
      <div id="container" className={`flex md:flex-row flex-col bg-gray-100 justify-between`}>
        <div className='flex flex-col w-full md:w-6/12 lg:w-7/12 gap-3'>
          {!isPWA && (
            <div className='flex justify-center '>
              <Image src={quad} alt="picture" className="rounded-lg shrink-0 object-cover w-full" />
            </div>
          )}

          <div ref={rootRef} id="map" className='md:h-screen h-96 w-full px-4'></div>

        </div>
        <div className='flex flex-col border-l-[#989797] gap-3 px-6 py-4 border-l-2 w-full md:w-6/12 lg:w-5/12'>
          <div className={`${inter.className} bg-[#EBF2FD] rounded-lg md:flex hidden flex-col items-start justify-center py-4 px-2`}>
            <h1 className='text-xl text-left font-bold'>{viewtickets?.name}</h1>
            <h1 className='text-base text-left text-[#989797] font-normal'>{viewtickets?.venue?.name} - {viewtickets?.venue?.location}</h1>
            <h1 className='text-[#397BEA] text-left text-base font-normal'>{formatDay(viewtickets?.occurs_at)} {formatDate(viewtickets?.occurs_at)}, {formatYear(viewtickets?.occurs_at)} {formatTime(viewtickets?.occurs_at)}</h1>
          </div>

          {selectedTicketGroup ?
            (
              <div className='flex flex-col gap-2 transition ease-in-out data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:duration-500'>
                <div className='flex items-center gap-2 font-black  ' onClick={() => { setSelectedTicketGroup(null) }}>
                  <GoArrowLeft className='h-6 w-6 ' />

                  <div className={`text-[16px] font-bold text-[#4D4A4A] cursor-pointer ${roboto.className}`} >Back</div>
                </div>
                <div id="ticketGroups" className='flex flex-col gap-6  py-4'>
                  <div className='bg-white rounded-xl lg:py-4 lg:px-8  p-2 w-full flex justify-between cursor-pointer transition duration-300 hover:shadow-sm hover:scale-[1.02]'>
                    <div className='w-full flex justify-between'>
                      <div className='w-[60%] lg:w-auto'>
                        {createHeading(selectedTicketGroup.section, selectedTicketGroup.row)}
                        {ticketType !== 'parking' && createQuantity(selectedTicketGroup.splits)}
                        {createType(selectedTicketGroup.format)}

                        {/* <div className='flex flex-row items-center gap-1'>
                        <h1 className='text-gray-400 text-xs'>Clear view </h1>
                        <IoIosInformationCircleOutline className='font-bold text-gray-400' />
                      </div> */}

                      </div>

                      <div className='flex flex-col items-end'>
                        <div className='font-bold text-[#40B41C]'>CA$ {(cad_rate * selectedTicketGroup.retail_price).toFixed(2)}</div>
                        <h2 className='text-sm text-gray-400'>each</h2>

                        {selectedTicketGroup.wheelchair && (
                          <div className='w-[24px] sm:w-[52px] h-[24px] sm:h-[48px] p-1 bg-[#FFF2E9] rounded-sm flex flex-col items-start sm:items-center justify-center gap-1'>
                            <div><Image src={'/wheelchair.svg'} alt='wheelchair' width={16} height={16} /></div>
                            <div className='hidden sm:block'>
                              <p className={`text-[8px] font-base text-[#FF801F] text-center leading-none ${roboto.className}`}>Wheelchair accessible</p>
                            </div>
                          </div>
                        )}
                        {selectedTicketGroup?.tevo_section_name &&
                          (selectedTicketGroup.tevo_section_name.toLowerCase().includes("standing") ||
                            selectedTicketGroup.tevo_section_name.toLowerCase().includes("sro")) && (
                            <div className='w-[24px] sm:w-[52px] h-[24px] sm:h-[48px] p-1 rounded-sm flex flex-col items-start sm:items-center justify-center gap-1'>
                              <div>
                                <Image src={'/standing.svg'} alt='standing' width={16} height={16} />
                              </div>
                              <div className='hidden sm:block'>
                                <p className={`text-[8px] font-base text-[#4169E1] text-center leading-none ${roboto.className}`}>
                                  Standing Ticket
                                </p>
                              </div>
                            </div>
                          )
                        }



                      </div>
                    </div>
                  </div>

                  {selectedTicketGroup.public_notes && (
                    <div className='flex flex-row gap-2 bg-[#f89921] rounded-lg p-2 items-center sm:items-start'>
                      <div className='justify-center items-center w-[50px] flex'>
                        <Image src='/information1.svg' alt="info1" width={24} height={24} />
                      </div>

                      <div className="mt-[2px]">
                        {selectedTicketGroup.public_notes.includes("XFER") ? (
                          <p className={`text-[#ffffff] ${roboto.className} font-normal text-xs`}>
                            Mobile Transfer
                          </p>
                        ) : (
                          <p className={`text-[#ffffff] ${roboto.className} font-normal text-xs`}>
                            {selectedTicketGroup.public_notes}
                          </p>
                        )}
                      </div>
                    </div>
                  )}


                  {/* {createQuantity(ticketGroup.retail_price)} */}
                  <div className='flex flex-row py-3 px-4 border-y-2 border-gray-500 justify-between'>
                    <div className='flex flex-col gap-1 items-start'>
                      <h1 className='font-bold'>Ticket Price</h1>
                      {
                        quantityFilter !== 'All' ? quantityFilter === 11 ? (
                          <div className='font-bold text-[#397BEA]'>CA$ {(cad_rate * selectedTicketGroup.retail_price * (selectedTicketGroup.splits.find((split) => split === 11) || selectedTicketGroup.splits.find((split) => split > 11) || selectedTicketGroup.splits[0])).toFixed(2)}</div>
                        ) : (
                          <div className='font-bold text-[#397BEA]'>CA$ {(cad_rate * selectedTicketGroup.retail_price * quantityFilter).toFixed(2)}</div>
                        ) : (
                          <div className='font-bold text-[#397BEA]'>CA$ {(cad_rate * selectedTicketGroup.retail_price * selectedTicketGroup.splits[0]).toFixed(2)}</div>
                        )
                      }
                    </div>

                    <div className='flex flex-col gap-1 items-start'>
                      <h1 className='text-[13px] font-normal text-[#6A6868]'>Quantity</h1>
                      <div className="flex flex-row items-center gap-1" ref={dropdownRef}>
                        {isEditing ? (
                          // <div className='custom-dropdown'>
                          //   <div>
                          //     {/* {quantityFilter} Ticket{(quantityFilter !== 'All' && quantityFilter > 1) && 's' } */}
                          //     {quantityFilter !== 'All' ? quantityFilter === 11 ? `${selectedTicketGroup.splits.find((split) => split === 11) || selectedTicketGroup.splits.find((split) => split > 11) || selectedTicketGroup.splits[0]} Tickets` : `${quantityFilter} Ticket${quantityFilter > 1 ? 's' : ''}` : `${selectedTicketGroup.splits[0]} Ticket${selectedTicketGroup.splits[0] > 1 ? 's' : ''}`}
                          //   </div>
                          //   <div className='absolute bg-white border-2 rounded-xl p-1 max-h-70 w-[120px] overflow-y-auto'>
                          //     {selectedTicketGroup.splits.map((value, index) => (
                          //       <div
                          //         key={index}
                          //         onClick={() => {
                          //           const updatedTicketGroup = {
                          //             ...selectedTicketGroup,
                          //             quantity: value
                          //           };
                          //           setSelectedTicketGroup(updatedTicketGroup);
                          //           setQuantityFilter(value);
                          //           setIsEditing(false);
                          //         }}
                          //         className='cursor-pointer hover:bg-gray-200 px-2 py-1 rounded'
                          //       >
                          //         {value} Ticket{value > 1 ? 's' : ''}
                          //       </div>
                          //     ))}
                          //   </div>
                          // </div>
                          <div className='custom-dropdown'>
                            <div>
                              {quantityFilter !== 'All'
                                ? quantityFilter === 11
                                  ? `${selectedTicketGroup.splits.find((split) => split === 11) || selectedTicketGroup.splits.find((split) => split > 11) || selectedTicketGroup.splits[0]} Tickets`
                                  : `${quantityFilter} Ticket${quantityFilter > 1 ? 's' : ''}`
                                : `${selectedTicketGroup.splits[0]} Ticket${selectedTicketGroup.splits[0] > 1 ? 's' : ''}`}
                            </div>
                            <div className={`absolute bg-white border-2 rounded-xl p-1  ${isPWA ? 'max-h-40 overflow-y-auto w-[120px] shadow-lg' : ''} dropdown-container`}>
                              {selectedTicketGroup.splits.map((value, index) => (
                                <div
                                  key={index}
                                  onClick={() => {
                                    const updatedTicketGroup = {
                                      ...selectedTicketGroup,
                                      quantity: value
                                    };
                                    setSelectedTicketGroup(updatedTicketGroup);
                                    setQuantityFilter(value);
                                    setIsEditing(false);
                                  }}
                                  className='cursor-pointer hover:bg-gray-200 px-2 py-1 rounded'
                                >
                                  {value} Ticket{value > 1 ? 's' : ''}
                                </div>
                              ))}
                            </div>
                          </div>


                        ) : (
                          <div>
                            {/* {quantityFilter} Ticket{(quantityFilter !== 'All' && quantityFilter > 1) && 's'} */}
                            {quantityFilter !== 'All' ? quantityFilter === 11 ? `${selectedTicketGroup.splits.find((split) => split === 11) || selectedTicketGroup.splits.find((split) => split > 11) || selectedTicketGroup.splits[0]} Tickets` : `${quantityFilter} Ticket${quantityFilter > 1 ? 's' : ''}` : `${selectedTicketGroup.splits[0]} Ticket${selectedTicketGroup.splits[0] > 1 ? 's' : ''}`}
                          </div>
                        )}

                        <MdModeEdit onClick={() => setIsEditing(!isEditing)} />
                      </div>
                    </div>
                    {/* <h2 className='text-sm text-gray-400'>each</h2> */}
                  </div>
                  <div className='flex flex-col w-full lg:flex-row gap-2'>
                    <button className='lg:w-1/2 w-full text-[#011E7B] border-[#011E7B] border-2 text-base font-bold rounded-full p-4' onClick={() => addToCart(selectedTicketGroup, viewtickets)} >Add to Cart</button>
                    <div className='lg:w-1/2'>
                      <Link href="/buynow">
                        <button className='w-full bg-[#011E7B] text-white flex justify-center items-center text-base font-bold rounded-full p-4' disabled={loading} onClick={() => addtobuyNow(selectedTicketGroup, viewtickets)}>{loading ? <div className='flex items-center gap-2'><Loader2 className='mr-2 h-4 w-4 animate-spin' /> Please wait </div> : 'Buy Now'}</button>
                      </Link>
                    </div>

                    {isPWA && (
                      <><br /><br /></>
                    )}
                  </div>
                </div>
                {/* <button onClick={() => { setSelectedTicketGroup(null) }}>cross</button> */}
              </div>
            )
            :
            (
              <div className='flex flex-col gap-3 w-full'>
                <div className='flex gap-2 flex-col '>
                  <div className='flex border-b-2 pb-2 border-[#CCCCCC] max-lg:gap-2 gap-1 items-start min-[1300px]:items-center max-[1300px]:flex-col-reverse min-[1300px]:justify-between'>
                    <h1 className='' >{availableTicketGroups.length} Listing's</h1>
                    <div className={`flex max-md:flex-row items-start flex-row gap-2 ${ticketType === 'parking' && 'opacity-50 pointer-events-none'}`}>

                      <div className={` ${roboto.className}`}>
                        <div className='flex' onClick={toggleDropdown}>
                          {/* <CgSortAz className='w-6 h-6' /> */}
                          <div className='px-3 py-1 gap-1 h-9 rounded border text-sm lg:text-lg border-neutral-400 hover:text-black-500 focus:outline-none font-bold flex flex-row items-center justify-center text-gray-500'>
                            <h1 className='font-bold'>{sortbystate}</h1>
                            <FaChevronDown />
                          </div>
                          {isOpen && (
                            <div id="dropdown" className="z-10 absolute mt-10 bg-white divide-y divide-gray-100 rounded-lg shadow w-42 dark:bg-gray-700">
                              <ul className="py-2 text-sm font-bold text-gray-700 dark:text-gray-200" aria-labelledby="dropdownDefaultButton">
                                <li>
                                  <a href="#" title="Price Low to High" className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white" onClick={() => handleDropdownChange("retail_price", "ASC")}>Price Low to High</a>

                                </li>
                                <li>
                                  <a href="#" title="Price High to Low" className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white" onClick={() => handleDropdownChange("retail_price", "DESC")}>Price High to Low</a>
                                </li>
                                <li>
                                  <a href="#" title='Section-Descending' className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white" onClick={() => handleDropdownChange("section", "DESC")}>Section - Descending</a>
                                </li>
                                <li>
                                  <a href="#" title='Section-Ascending' className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white" onClick={() => handleDropdownChange("section", "ASC")}>Section - Ascending</a>
                                </li>
                                <li>
                                  <a href="#" title='Row-Descending' className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white" onClick={() => handleDropdownChange("row", "DESC")}>Row - Descending</a>
                                </li>
                                <li>
                                  <a href="#" title='Row-Ascending' className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white" onClick={() => handleDropdownChange("row", "ASC")}>Row - Ascending</a>
                                </li>
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className='flex justify-center items-center'>
                        <div className="gap-4 flex flex-row max-lg:overflow-x-scroll scrollbar-track-gray-100 scrollbar-thumb-gray-700 scroll-m-1">
                          <div className="inline-block text-left">

                            <Sheet key="right">
                              <SheetTrigger><div className="px-3 py-1 gap-1 h-9 rounded border text-lg border-neutral-400 hover:text-black-500 focus:outline-none font-bold flex flex-row items-center justify-center text-gray-500">
                                <CgSortAz className='w-6 h-6' />
                                <div className="font-bold text-sm lg:text-[19px]">Filters</div>
                              </div></SheetTrigger>
                              <SheetContent side={"right"} className='h-[390px] top-[5%] max-h-[90vh] overflow-y-auto'>
                                <SheetHeader className='h-[90%]'>
                                  <SheetTitle>
                                    <h1 className={`${oswalds.className} py-3 border-b-gray-400 border-b-2 text-4xl`}>Filters</h1>

                                  </SheetTitle>
                                  <SheetDescription className='overflow-y-auto'>
                                    <div className='pb-2 px-2'>
                                      <div className="flex flex-col gap-2 text-left pb-5 border-b-gray-400 border-b-2">
                                        <h1 className='text-black text-lg font-bold'>Number of Tickets</h1>
                                        <Select value={quantityFilter !== 'All' ? quantityFilter > 10 ? '11' : quantityFilter.toString() : quantityFilter.toString()} onValueChange={(e) => { updateFilters('quantity', e) }}>
                                          <SelectTrigger className="w-full">
                                            <SelectValue placeholder="Quantity" />
                                          </SelectTrigger>
                                          <SelectContent className="!max-h-[400px]  overflow-y-auto">
                                            <SelectGroup>
                                              <SelectLabel>Quantity</SelectLabel>
                                              <SelectItem value="All">All Tickets</SelectItem>
                                              {Array.from({ length: 10 }, (_, i) => (
                                                <SelectItem key={i + 1} value={(i + 1).toString()}>{`${i + 1} Ticket${i + 1 > 1 ? 's' : ''}`}</SelectItem>
                                              ))}
                                              <SelectItem value="11">10+ Tickets</SelectItem>
                                            </SelectGroup>
                                          </SelectContent>
                                        </Select>
                                      </div>
                                      <div className='flex flex-col gap-2 pt-3 pb-10 text-left border-b-gray-400 border-b-2'>
                                        <h1 className='text-black text-lg font-bold'>Price per Ticket</h1>
                                        <div className="">
                                          {/* <span id="min-price">{minPriceFilter} {maxPriceFilter}</span> <input name="max-price" type="range" min={minPriceFilter} max={maxPriceFilter} step="10" onChange={(e) => updateFilters(e.target.name, e.target.value)} /> */}
                                          <div className='flex flex-row justify-between '>
                                            <h1>
                                              ${minPriceFilter}
                                            </h1>
                                            <h1>
                                              ${maxPriceFilter}
                                            </h1>
                                          </div>
                                          <div className=''>

                                            <ReactSlider className="horizontal-slider"
                                              thumbClassName="example-thumb"
                                              trackClassName="example-track"
                                              step={10}
                                              min={minPriceFilter} max={changePrice} value={maxPriceFilter} onChange={(e) => { updateFilters("max-price", e) }}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </SheetDescription>
                                </SheetHeader>
                                <SheetFooter className='h-[10%]'>
                                  <SheetClose asChild>
                                    <Button type="submit">Save changes</Button>
                                  </SheetClose>
                                </SheetFooter>
                              </SheetContent>
                            </Sheet>

                          </div>
                          {/* <div className="text-left">
                <input name="quantity" className='w-36 px-6 py-1 h-9 rounded-full border-2 border-neutral-400 text-[19px] font-bold text-gray-500' type="number" min="1" placeholder="Quantity" onChange={(e) => { updateFilters(e.target.name, e.target.value); console.log(e.target.value) }} />
              </div> */}
                        </div>
                      </div>
                    </div>
                  </div >
                </div>
                <Tabs defaultValue={ticketType} onValueChange={handleTicketTypeChange} className="w-full">
                  <TabsList className="w-full">
                    <TabsTrigger value="event" className="w-full font-base text-md data-[state=active]:text-[#3470D5] data-[state=active]:border-2 data-[state=active]:border-[#3470D5] flex gap-1 justify-center align-items-center">
                      <Image src="/allTicketsTab.svg" width={20} height={20} alt="event" />
                      <p>All Tickets</p>
                      <div className="bg-orange-500 text-white text-[10px] font-semibold rounded px-1.5 py-0.5">{availableTicketGroups.length}</div>
                    </TabsTrigger>
                    <TabsTrigger value="parking" className="w-full font-base text-md data-[state=active]:text-[#3470D5] data-[state=active]:border-2 data-[state=active]:border-[#3470D5] flex gap-1 justify-center align-items-center">
                      <Image src="/carparking1.svg" width={20} height={20} alt="parking" />
                      <p>Parking Pass</p>
                      <div className="bg-orange-500 text-white text-[10px] font-semibold rounded px-1.5 py-0.5">{parkingTickets.length}</div>
                    </TabsTrigger>
                  </TabsList>
                  <TabsContent value="event" className="w-full">
                    <div className='flex flex-col gap-4 '>
                      <div id="ticketGroups">{renderTicketGroupList(availableTicketGroups)}</div>
                    </div>
                  </TabsContent>
                  <TabsContent value="parking" className="w-full">
                    <div className='flex flex-col gap-4 '>
                      <div id="ticketGroups">{renderTicketGroupList(parkingTickets)}</div>
                    </div>
                  </TabsContent>
                </Tabs>
              </div>
            )
          }

        </div>
      </div>
      {/* {showPopup1 && (
        <DynamicPopup message={popupMessage} buttonText={buttonText} onClose={() => setShowPopup1(false)} />
      )} */}

    </div>
  );
};

export default App;